/**
 * URL manipulation utilities
 */

/**
 * Remove trailing slashes from a URL or path
 */
export function trimTrailingSlash(url: string): string {
  return (url || "").replace(/\/+$/, "");
}

/**
 * Safely join a base URL with a path, handling trailing/leading slashes
 */
export function joinUrl(base: string, path: string): string {
  const normalizedBase = trimTrailingSlash(base);
  const normalizedPath = path.startsWith("/") ? path : `/${path}`;
  return `${normalizedBase}${normalizedPath}`;
}

/**
 * Normalize a domain string by removing protocol and trailing slashes
 * e.g., "https://example.com/" -> "example.com"
 */
export function normalizeDomain(domain: string): string {
  return trimTrailingSlash((domain || "").trim().replace(/^https?:\/\//, ""));
}
